export interface ExtractedOrderData {
  firstName: string | null;
  lastName: string | null;
  date: string | null;
  time: string | null;
  persons: number | null;
  phone: string | null;
  source: string | null;
}

const DATE_RE = /(\d{2})\.(\d{2})\.(\d{4})/;
const TIME_RE = /ב-(\d{2}:\d{2})/;
const NAME_RE = /מ-([^!]+)/;
const TICKETS_RE = /מספר הכרטיסים שהוזמנו:\s*(\d+)/;

export function extractOrderDataFromMessage(text: string): ExtractedOrderData {
  const dateMatch = text.match(DATE_RE);
  const timeMatch = text.match(TIME_RE);
  const nameMatch = text.match(NAME_RE);
  const ticketsMatch = text.match(TICKETS_RE);

  let firstName: string | null = null;
  let lastName: string | null = null;
  if (nameMatch) {
    const parts = nameMatch[1].trim().split(/\s+/);
    firstName = parts[0] ?? null;
    lastName = parts.length > 1 ? parts[parts.length - 1] : null;
  }

  let date: string | null = null;
  if (dateMatch) {
    const [, day, month, year] = dateMatch;
    date = `${year}-${month}-${day}`;
  }

  return {
    firstName,
    lastName,
    date,
    time: timeMatch ? timeMatch[1] : null,
    persons: ticketsMatch ? parseInt(ticketsMatch[1], 10) : null,
    phone: null,
    source: 'externalPrefill.sources.funzing',
  };
}
